module.exports = __webpack_public_path__ + "img/cf_white.06de3ca5.svg";